import { mixpanel } from './config/mixpanelConfig';

export const trackPageView = (pageName = '') => {
  mixpanel.track_pageview({
    page: pageName,
  });
};
